import { action, makeObservable, observable } from 'mobx';

import { isNumberArray } from 'src/packages/utils/is-number-array';

import type { AxiosInstance } from 'axios';
import type { DirectoryTableMediator } from 'src/components/directory-table/directory-table-mediator';
import type { NotificationsService } from 'src/services/notifications-service';

import { PluginName, type IPlugin } from '../../types';

import { SyncWithDbApi } from './sync-with-db.api';

export class SyncWithDb implements IPlugin {
  private readonly api: SyncWithDbApi;
  private readonly notificationsService: NotificationsService;

  readonly name = PluginName.SyncWithDb;
  @observable tableMediator: DirectoryTableMediator | null = null;

  @observable isLoading = false;

  constructor(gatewayAgent: AxiosInstance, notificationsService: NotificationsService) {
    this.api = new SyncWithDbApi(gatewayAgent);
    this.notificationsService = notificationsService;

    makeObservable(this);
  }

  @action.bound
  setTableMediator(tableMediator: DirectoryTableMediator): void {
    this.tableMediator = tableMediator;
  }

  syncWithDb = async () => {
    const wellIds = this.tableMediator?.selectedRows;

    if (!isNumberArray(wellIds)) {
      console.error('wellIds is not a number array');
      return;
    }

    if (!wellIds || wellIds.length === 0) {
      console.error('wellIds is empty or not defined');
      return;
    }

    if (wellIds.length > 10) {
      this.notificationsService.showErrorMessageT('plugins:SyncWithDb.lotOfWells');
      return;
    }

    try {
      this.isLoading = true;
      await this.api.syncWithDb(wellIds);
      this.notificationsService.showSuccessMessageT('plugins:SyncWithDb.successSyncing');
    } catch (e) {
      this.notificationsService.showErrorMessageT('plugins:SyncWithDb.errorSyncing');
      console.error(e);
    } finally {
      this.isLoading = false;
    }
  };
}
